import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Box } from '../../components/Box/index.js';
import { alignYToFlex } from '../../components/Inline/consts.js';
/**
 * If you’d like to render a set of components in a row with equal spacing
 * around them, wrapping onto multiple lines when necessary, we provide the
 * Inline component.
 */
export const Inline = /*#__PURE__*/_styled(({
  children,
  align = 'start',
  alignY = 'top',
  space = 0,
  rowSpace,
  noWrap,
  ...restProps
}) => {
  return _jsx(Box, {
    display: "flex",
    flexDirection: "row",
    gap: space,
    rowGap: rowSpace,
    flexWrap: noWrap ? 'nowrap' : 'wrap',
    alignItems: alignYToFlex[alignY],
    justifyContent: align,
    ...restProps,
    children: children
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e1hh4a9h0"
} : {
  target: "e1hh4a9h0",
  label: "Inline"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIklubGluZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFXRyIsImZpbGUiOiJJbmxpbmUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdC9qc3gtcnVudGltZVwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgQm94IH0gZnJvbSAnLi4vLi4vY29tcG9uZW50cy9Cb3gvaW5kZXguanMnO1xuaW1wb3J0IHsgYWxpZ25ZVG9GbGV4IH0gZnJvbSAnLi4vLi4vY29tcG9uZW50cy9JbmxpbmUvY29uc3RzLmpzJztcbi8qKlxuICogSWYgeW914oCZZCBsaWtlIHRvIHJlbmRlciBhIHNldCBvZiBjb21wb25lbnRzIGluIGEgcm93IHdpdGggZXF1YWwgc3BhY2luZ1xuICogYXJvdW5kIHRoZW0sIHdyYXBwaW5nIG9udG8gbXVsdGlwbGUgbGluZXMgd2hlbiBuZWNlc3NhcnksIHdlIHByb3ZpZGUgdGhlXG4gKiBJbmxpbmUgY29tcG9uZW50LlxuICovXG5leHBvcnQgY29uc3QgSW5saW5lID0gc3R5bGVkKCh7IGNoaWxkcmVuLCBhbGlnbiA9ICdzdGFydCcsIGFsaWduWSA9ICd0b3AnLCBzcGFjZSA9IDAsIHJvd1NwYWNlLCBub1dyYXAsIC4uLnJlc3RQcm9wcyB9KSA9PiB7XG4gICAgcmV0dXJuIChfanN4KEJveCwgeyBkaXNwbGF5OiBcImZsZXhcIiwgZmxleERpcmVjdGlvbjogXCJyb3dcIiwgZ2FwOiBzcGFjZSwgcm93R2FwOiByb3dTcGFjZSwgZmxleFdyYXA6IG5vV3JhcCA/ICdub3dyYXAnIDogJ3dyYXAnLCBhbGlnbkl0ZW1zOiBhbGlnbllUb0ZsZXhbYWxpZ25ZXSwganVzdGlmeUNvbnRlbnQ6IGFsaWduLCAuLi5yZXN0UHJvcHMsIGNoaWxkcmVuOiBjaGlsZHJlbiB9KSk7XG59KSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUlubGluZS5qcy5tYXAiXX0= */");